export default __webpack_public_path__ + "static/media/logoMinimal.b675f2fc.png";